import sendoff from "../images/bottle_moving.gif"

export default function SendoffGif() {
    
    return (
            <div>
                <img src={sendoff} alt="gif of bottle floating away"/>
            </div>
    );
};




